function initialiseHomeOrdering(root=document) {
  root.querySelectorAll('[data-loaf-home-order]').forEach(link => {
    if (link.dataset.orderInitialised) return;
    link.dataset.orderInitialised='true';
    link.addEventListener('click', event => {
      const picker=document.querySelector('#SiteHeader .loaf-order-picker');
      if (!picker) return;
      event.preventDefault();
      event.stopPropagation();
      picker.open=true;
      document.getElementById('SiteHeader').scrollIntoView({block:'start'});
      picker.querySelector('a').focus({preventScroll:true});
    });
  });
}
initialiseHomeOrdering();

document.addEventListener('shopify:section:load',event=>initialiseHomeOrdering(event.target));

const homeCarouselControls = new WeakMap();

function initialiseHomeCarouselControls(root = document) {
  root.querySelectorAll('.hero[data-dots="true"]').forEach(hero => {
    if (homeCarouselControls.has(hero)) return;
    let frame = 0;
    let observedDots = null;
    const titles = [...hero.querySelectorAll('.slideshow__slide')].map(slide =>
      slide.querySelector('.hero__title')?.textContent.trim()
    );
    const update = () => {
      frame = 0;
      hero.querySelectorAll('.flickity-page-dots .dot').forEach((dot, index) => {
        let button = dot.querySelector('.loaf-slide-dot');
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'loaf-slide-dot';
          button.setAttribute('aria-label', titles[index] || dot.getAttribute('aria-label') || String(index + 1));
          button.addEventListener('click', event => { event.stopPropagation(); dot.click(); });
          dot.removeAttribute('aria-label');
          dot.appendChild(button);
        }
        const current = dot.classList.contains('is-selected') ? 'true' : 'false';
        if (button.getAttribute('aria-current') !== current) button.setAttribute('aria-current', current);
      });
      const dots = hero.querySelector('.flickity-page-dots');
      if (dots && dots !== observedDots) {
        observer.disconnect();
        observer.observe(dots, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
        observedDots = dots;
      }
    };
    const scheduleUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const observer = new MutationObserver(records => {
      if (!observedDots || records.some(record =>
        record.type === 'childList' || record.target.matches('.dot')
      )) scheduleUpdate();
    });
    // Watch for Flickity's initial pagination, then limit observation to its dots.
    observer.observe(hero, {subtree: true, childList: true});
    homeCarouselControls.set(hero, () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
      homeCarouselControls.delete(hero);
    });
    update();
  });
}
initialiseHomeCarouselControls();

document.addEventListener('shopify:section:load', event => initialiseHomeCarouselControls(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('.hero[data-dots="true"]').forEach(hero => homeCarouselControls.get(hero)?.());
});
